import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AddAccountLinkedinDialog } from '../../components/AddAccountLinkedinDialog';
import { AddAssociatedAccountDialog } from '../../components/AddAssociatedAccountDialog';

export const AccountAssociatedNewPage = (

):JSX.Element => {
  const [isOpenDialogLinkedin, setDialogOpenLinkedin] = useState<boolean>(true);
  const [isOpenDialogCreateNewAccount, setIsOpenDialogCreateNewAccount] = useState<boolean>(false);
  const [associatedCompany, setAssociatedCompany] = useState<Company | undefined>(undefined);
  const [linkedinUrl, setLinkedinUrl] = useState('');

  const navigate = useNavigate();
  const handleCancel = () => {
    navigate(-1);
  };
  
  const handleCompanyReady = (company: Company) => {
    setAssociatedCompany(company);
    setDialogOpenLinkedin(false);
    setIsOpenDialogCreateNewAccount(true);
  };
  
  const handleLinkedinValueChanged = (e:React.ChangeEvent<HTMLInputElement>) => {
    setLinkedinUrl(e.target.value);
  };

  const handleChangeCompanyClicked = () => {
    setIsOpenDialogCreateNewAccount(false);
    setDialogOpenLinkedin(true);
  };

  if (isOpenDialogLinkedin) {
    return (
      <AddAccountLinkedinDialog
        onCompanyReady={ handleCompanyReady }
        onCancelClick={ handleCancel }
        isShowDialog={ isOpenDialogLinkedin }
        onLinkedinValueChange={ handleLinkedinValueChanged }
        linkedinUrl={ linkedinUrl }
      />
    );
  }

  return (
    <AddAssociatedAccountDialog
      isShowDialog={ isOpenDialogCreateNewAccount }
      associatedCompany={ associatedCompany }
      linkedinUrl={ linkedinUrl }
      onCancelClick={ handleCancel  }
      onChangeCompanyClicked={ handleChangeCompanyClicked }
    />
  );
};
